import { SystemStyleObject } from '@vimeo/bokeh';

export const PAGE_WRAPPER_STYLE: SystemStyleObject = {
  flexDirection: 'column',
  alignItems: 'center',
  flexGrow: 1,
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  background: 'surface', //core.color.surface(800)?
};
